var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02979 22.75H15.0298C20.4598 22.75 22.7798 20.43 22.7798 15V9C22.7798 3.57 20.4598 1.25 15.0298 1.25H9.02979C3.59978 1.25 1.27979 3.57 1.27979 9V15C1.27979 20.43 3.58978 22.75 9.02979 22.75ZM15.0298 2.75C19.6398 2.75 21.2798 4.39 21.2798 9V15C21.2798 19.61 19.6398 21.25 15.0298 21.25H9.02979C4.41978 21.25 2.77979 19.61 2.77979 15V9C2.77979 4.39 4.41978 2.75 9.02979 2.75H15.0298Z",
    fill: "#494C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02979 22.75C9.43979 22.75 9.77979 22.41 9.77979 22V2C9.77979 1.59 9.43979 1.25 9.02979 1.25C8.61979 1.25 8.27979 1.59 8.27979 2V22C8.27979 22.41 8.60979 22.75 9.02979 22.75Z",
    fill: "#494C50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0298 15.31C16.2198 15.31 16.4098 15.24 16.5598 15.09C16.8498 14.8 16.8498 14.32 16.5598 14.03L14.5298 12L16.5598 9.97001C16.8498 9.68001 16.8498 9.2 16.5598 8.91C16.2698 8.62 15.7898 8.62 15.4998 8.91L12.9398 11.47C12.6498 11.76 12.6498 12.24 12.9398 12.53L15.4998 15.09C15.6398 15.24 15.8298 15.31 16.0298 15.31Z",
    fill: "#494C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c68cb4de935b991153f15dbc83780af9.svg";
export { ForwardRef as ReactComponent };